import { AvGroup, AvForm } from "availity-reactstrap-validation";
import { StyledH2, StyledTextInput } from "@aureskonnect/react-ui";
import { numberMatchWord } from "@constants/index";
import React, { useEffect } from "react";
import { t } from "i18next";
import classnames from "classnames";
import {
    store,
    setIsValidationNumTheSpot,
    setIsValidationNumToTake,
    setIsValidationNumDelivrey,
    setOrders,
} from "../../store";
import { useSnapshot } from "valtio";
import { ErrorMessage } from "./Orders";

const PrepareTime = (props: {
    label: string;
    fieldKey: "delivery" | "onTheSpot" | "toTake";
    validationKey: any;
    validationSetter: any;
    value: any;
    handlechange: any;
    className: string;
    errorFontSize?: string;
    hasMarginTop?: boolean;
}) => {
    return (
        <AvGroup className=" d-flex justify-content-align mt-3 ml-3 px-5">
            <span
                className="mt-2 ml-5"
                style={{
                    font: "normal normal 400 16px/24px Segoe UI",
                    color: "#000000",
                    opacity: "1",
                    width: "329px",
                }}
            >
                {props.label}
            </span>

            <StyledTextInput
                min="0"
                onKeyPress={(event: any) => {
                    if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                    }
                }}
                id={props.fieldKey}
                name={props.fieldKey}
                type="number"
                onChange={(e: any) => {
                    props.handlechange(
                        props.fieldKey,
                        e.target.value,
                        props.validationSetter
                    );
                }}
                value={props.value.toString()}
                className={classnames(props.className, {
                    input__clz: props.validationKey || props.value > 60,
                })}
                style={{
                    width: "110px",
                    marginTop: props.hasMarginTop ? "5px" : "0px",
                    height: "40px",
                }}
            />

            {props.validationKey && props.value <= 60 && (
                <ErrorMessage
                    message={t("Please insert a preparation time")}
                    fontSize={props.errorFontSize || "75"}
                />
            )}
            {props.value > 60 && (
                <ErrorMessage
                    message={t("The entered value must be between 0 and 60")}
                    fontSize="80"
                />
            )}
        </AvGroup>
    );
};

function OrdersTimePreparation({ selectedRows }: any) {
    const {
        isValidationNumTheSpot,
        isValidationNumToTake,
        isValidationNumDelivrey,
    } = useSnapshot(store);

    const getInitialPreparationTimes = () => {
        if (
            !selectedRows?.length ||
            !selectedRows[0]?.["Temps de préparation"]
        ) {
            return { onTheSpot: 15, toTake: 15, delivery: 30 };
        }

        const temps = selectedRows[0]["Temps de préparation"]
            .replaceAll(";", ",")
            .split(",")
            .map(Number);

        return {
            onTheSpot: temps[0] || 15,
            toTake: temps[1] || 15,
            delivery: temps[2] || 30,
        };
    };

    const [preparationTimes, setPreparationTimes] = React.useState(
        getInitialPreparationTimes
    );

    useEffect(() => {
        const timePrepartion = `${preparationTimes.onTheSpot};${preparationTimes.toTake};${preparationTimes.delivery}`;
        setOrders({ ...preparationTimes, timePrepartion });
        // eslint-disable-next-line
    }, []);

    const updatePreparationTime = (
        field: keyof typeof preparationTimes,
        value: number
    ) => {
        const newTimes = {
            ...preparationTimes,
            [field]: value,
        };
        setPreparationTimes(newTimes);
        const timePrepartion = `${newTimes.onTheSpot};${newTimes.toTake};${newTimes.delivery}`;
        setOrders({ ...newTimes, timePrepartion });
    };

    const handleTimeChange = (
        field: keyof typeof preparationTimes,
        value: string,
        validationSetter: any
    ) => {
        if (value.match(numberMatchWord) || value === "0") {
            const numericValue = parseInt(value, 10);
            updatePreparationTime(field, numericValue);
            validationSetter(false);
        } else {
            validationSetter(true);
        }
    };

    return (
        <div>
            <StyledH2
                style={{
                    font: "normal normal 400 20px/27px Segoe UI",
                    color: "#000000",
                    opacity: "1",
                }}
                className="ml-5 pt-3"
            >
                {t("Preparation time required for an order (in minutes)")}
            </StyledH2>
            <AvForm>
                {/* Use only PrepareTime components, remove the duplicate AvGroups */}
                <PrepareTime
                    label={t("Delivery")}
                    fieldKey={"delivery"}
                    validationKey={isValidationNumDelivrey}
                    validationSetter={setIsValidationNumDelivrey}
                    value={preparationTimes.delivery}
                    handlechange={handleTimeChange}
                    className="cac_inp_preparationTimeDelivery"
                    errorFontSize="75"
                    hasMarginTop={true}
                />

                <PrepareTime
                    label={t("On the spot")}
                    fieldKey={"onTheSpot"}
                    validationKey={isValidationNumTheSpot}
                    validationSetter={setIsValidationNumTheSpot}
                    value={preparationTimes.onTheSpot}
                    handlechange={handleTimeChange}
                    className="cac_inp_preparationTimeOnTheSpot"
                    errorFontSize="75"
                    hasMarginTop={false}
                />

                <PrepareTime
                    label={t("To take")}
                    fieldKey={"toTake"}
                    validationKey={isValidationNumToTake}
                    validationSetter={setIsValidationNumToTake}
                    value={preparationTimes.toTake}
                    handlechange={handleTimeChange}
                    className="cac_inp_preparationTimeTakeAway"
                    errorFontSize="80"
                    hasMarginTop={false}
                />
            </AvForm>
        </div>
    );
}

export default OrdersTimePreparation;
